__turbopack_context__.v({
  "cloud": "WeatherStation-module__M8UNxq__cloud",
  "cloudWrapper": "WeatherStation-module__M8UNxq__cloudWrapper",
  "frame": "WeatherStation-module__M8UNxq__frame",
  "house": "WeatherStation-module__M8UNxq__house",
  "houseTree": "WeatherStation-module__M8UNxq__houseTree",
  "inner": "WeatherStation-module__M8UNxq__inner",
  "moon": "WeatherStation-module__M8UNxq__moon",
  "root": "WeatherStation-module__M8UNxq__root",
  "sun": "WeatherStation-module__M8UNxq__sun",
  "sunAnchor": "WeatherStation-module__M8UNxq__sunAnchor",
});
